const ExportParamActions = {
    START_LOAD: "export-param/start-load",
    LOADED: "export-param/loaded",
    LOAD_ERROR: "export-param/load-error",
    INVALIDATE_CACHE: "export-param/invalidate-cache",

    CREATE: "export-param/create",
    CREATED: "export-param/created",
    CREATE_ERROR: "export-param/create-error",

    RENAME: "export-param/rename",
    RENAMED: "export-param/renamed",
    RENAME_ERROR: "export-param/rename-error",

    UPDATE: "export-param/update",
    UPDATED: "export-param/updated",
    UPDATE_ERROR: "export-param/update-error",

    DELETE: "export-param/delete",
    DELETED: "export-param/deleted",
    DELETE_ERROR: "export-param/delete-error",
};

export default ExportParamActions;



// WEBPACK FOOTER //
// ./app/data/ExportParamActions.js